<template>
  <div>
    <div class="file_search">
      <a-input-search placeholder="按文件名搜索" style="width: 180px" v-model="fileName" @change="searchHandler" />
    </div>
    <div class="file_content">
      <div style="flex: auto">
        <a-table size="small" :loading="loading" :columns="columns" :dataSource="list" :pagination="false" :rowKey="row => row.id">
          <div slot="name" slot-scope="row" @click="clickItem(row)">
            <file-icon :type="row.filetype" :fileName="row.name" :imageSrc="row.imageLink"></file-icon>
            <a-button type="link">
              {{ row.name }}
            </a-button>
          </div>

          <span slot="creator"></span>
          <span slot="sizeDesc" slot-scope="sizeDesc">{{ sizeDesc }}</span>
          <span slot="time" slot-scope="time">{{ time }}</span>
        </a-table>
        <div class="file_pagination" v-if="totalNum > 0">
          <a-pagination
            size="small"
            showSizeChanger
            :pageSize="pageSize"
            :total="totalNum"
            :current="currentPage"
            @change="changePage"
            @showSizeChange="changeSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { feishuGroupFileList, viewResources } from '@/api/companyGroup.js';
import FileIcon from '@/components/base/fileIcon';
import { mapGetters } from 'vuex';
export default {
  components: {
    FileIcon
  },
  props: {
    projectId: {
      type: String
    },
    groupId: {
      type: String,
      default: ''
    }
  },
  watch: {
    groupId() {
      this.getList();
    }
  },
  data() {
    return {
      columns: [
        { title: '标题', scopedSlots: { customRender: 'name' }, width: 250 },
        {
          title: '分享人',
          dataIndex: 'nickname',
          align: 'center',
          width: 50
        },
        {
          title: '外链站点',
          dataIndex: 'source',
          align: 'center',
          width: 50
        },

        {
          title: '分享时间',
          dataIndex: 'sendTime',
          align: 'center',
          scopedSlots: { customRender: 'time' },
          width: 100
        }
      ],
      list: [],
      loading: false,
      documentList: [],
      pageSize: 10,
      totalNum: 0,
      currentPage: 1,
      fileName: ''
    };
  },
  computed: {
    ...mapGetters(['token'])
  },
  mounted() {
    this.getList();
  },

  methods: {
    changePage(value) {
      this.currentPage = value;
      this.getList();
    },
    changeSize(page, size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    async clickItem(item) {
      let url;
      let res = await viewResources({ id: item.id });
      if (res.code === 200) {
        let url = res.data.filePath;
        if (item.type === 3 || item.type === 0) {
          let routeLink = this.$router.resolve({ path: '/pdfview', query: { url: url + '?Authorization=' + this.token, type: res.data.viewType } });
          url = routeLink.href;
        }
        url && window.open(url);
      }
    },
    searchHandler() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      feishuGroupFileList({
        groupId: this.groupId,
        searchName: this.fileName,
        page: this.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res.code === 200) {
            this.$emit('updateData');
            this.list = res.data.list
              ? res.data.list.map(i => {
                return {
                  ...i,
                  filetype: i.type === 0 ? 'png' : ''
                };
              })
              : [];
            this.list.forEach(async i => {
              if (i.type === 0) {
                let re = await viewResources({ id: i.id });
                if (re.code === 200) {
                  i.imageLink = re.data.filePath + '?Authorization=' + this.token;
                  i.name = '点击打开图片';
                }
              }
            });
            this.totalNum = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.file_search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  padding: 0 10px;
}
.file_content {
  display: flex;
  flex: auto;
  .ant-table-wrapper {
    width: 100%;
  }
  .ant-menu-vertical {
    border: none !important;
  }
}
.file_pagination {
  margin: 10px 0;
  text-align: right;
}
</style>
